import * as RadixTabs from "@radix-ui/react-tabs";
import { useRouter } from "next/router";

const classes = {
  tablist: ``,
  tabTrigger: `
  h-2.75em px-1em
  rd-0.5em  fw-500 cursor-pointer appearance-none underline-none text-center whitespace-nowrap leading-1em
  focus-visible:outline-prm11
  focus:outline-prm9
  focus:outline-offset-3
  focus:outline-1.5
  b-transparent
  data-[state=active]:b-sand7
  hover:bg-sand4
  data-[state=active]:bg-sandA-4
  `,
  tabContent: ``,
};

export default function Tabs({
  children,
  ...props
}: {
  children: React.ReactNode;
} & RadixTabs.TabsProps) {
  const { locale } = useRouter();
  return (
    <RadixTabs.Root dir={locale === "fa" ? "rtl" : "ltr"} className="" {...props}>
      {children}
    </RadixTabs.Root>
  );
}

const TabsList = (props: RadixTabs.TabsListProps) => <RadixTabs.TabsList className={props.className} {...props} />;
TabsList.displayName = "Tabs.TabsList";

const Content = (props: RadixTabs.TabsContentProps) => <RadixTabs.Content className={props.className} {...props} />;
Content.displayName = "Tabs.Content";

const Trigger = (props: RadixTabs.TabsTriggerProps) => (
  <RadixTabs.Trigger className={`${classes.tabTrigger} ${props.className} `} {...props} />
);

Tabs.Content = Content;
Tabs.Trigger = Trigger;
Tabs.TabsList = TabsList;
